// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"e6759797","382":"007e313d"}[chunkId] + ".chunk.js";
};